<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i>Loading
        </div>

        <div v-else>
            <vue-headful :title="'Delete JSA :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/jsa`">
                            <i class="fa fa-files-o"></i> JSA
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/jsa/view/${jsa.jsa_id}`">
                            {{ jsa.jsa_name }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        <i class="fa fa-trash"></i> Delete
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-8 col-lg-12">
                    <div class="card mb-3">
                        <div class="card-header">
                            <strong>Delete JSA: {{ jsa.jsa_name }}</strong>
                        </div>
                        <div class="card-body">
                            <div class="alert alert-danger">Are you sure you want to delete this JSA? This is permanent and cannot be undone. All associated files will also be deleted.</div>
                        </div>
                        <div class="card-footer">
                            <button class="btn btn-sm btn-danger" v-on:click="deleteJsa()" :disabled="deleting">
                                <template v-if="deleting"><i class="fa fa-spin fa-spinner"></i> Deleting</template>
                                <template v-else>Delete JSA</template>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                deleting: false,
                jsa_id: this.$route.params.id,
                jsa: {},
                files: [],
            }
        },

        computed: {

        },

        methods: {

            getJsa: function() {
                //Get the data
                this.$http
                    .get('jsa/delete/' + this.jsa_id)
                    .then(response => {
                        //Set all the data
                        this.jsa = response.data.jsa;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            deleteJsa(){
                //Helper
                this.deleting = true;

                //Get the data
                this.$http
                    .post('jsa/delete/' + this.jsa_id)
                    .then(response => {
                        //Alert the user
                        this.$toastr.success('JSA Deleted');

                        //Send to the list
                        this.$router.push('/jsa');
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Reset
                        this.deleting = false;
                    });
            },

        },

        mounted() {
            //Get the JSA
            this.getJsa();
        }
    }
</script>